import { Card } from "@babylonlabs-io/core-ui";

import { Section as SectionContainer } from "@/ui/common/components/Section/Section";
import { getNetworkConfigBTC } from "@/ui/common/config/network/btc";
import { useAppState } from "@/ui/common/state";

import { Question, questionsBaby, questionsBtc } from "./data/questions";
import { Section } from "./Section";

type FaqVariant = "btc" | "baby";

interface FAQProps {
  variant: FaqVariant;
}

export const FAQ = ({ variant }: FAQProps) => {
  const { networkInfo } = useAppState();
  const btcConfirmationDepth =
    networkInfo?.params.btcEpochCheckParams?.latestParam?.btcConfirmationDepth;

  let items: Question[] = [];

  if (variant === "btc") {
    const { coinName } = getNetworkConfigBTC();
    items = questionsBtc({ coinName, btcConfirmationDepth });
  } else if (variant === "baby") {
    items = questionsBaby;
  }

  return (
    <SectionContainer titleClassName="md:text-[1.25rem] mt-10">
      <Card className="flex flex-col gap-4 divide-y divide-secondary-strokeLight !border-0 bg-secondary-highlight">
        {items.map((question) => (
          <Section
            key={question.title}
            title={question.title}
            content={question.content}
          />
        ))}
      </Card>
    </SectionContainer>
  );
};
